import { Component, OnInit, OnDestroy } from '@angular/core';
import { DuplicateTabGuardService } from '../../services/duplicate-tab-guard.service';
import { Subscription } from 'rxjs';

@Component({ standalone: false,
  selector: 'app-duplicate-tab-error',
  template: `
    <div class="duplicate-tab-fullscreen" *ngIf="showDuplicateError">
      <div class="duplicate-tab-message">
        <h1>You already have this app open in another tab.</h1>
      </div>
    </div>
  `,
  styles: [`
    .duplicate-tab-fullscreen {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 10000000; /* Highest z-index to ensure it's always on top */
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    }

    .duplicate-tab-message {
      text-align: center;
      padding: 40px;
      max-width: 600px;
    }

    .duplicate-tab-message h1 {
      font-size: 32px;
      font-weight: 400;
      color: #333333;
      margin: 0;
      line-height: 1.4;
    }

    /* Dark mode support */
    @media (prefers-color-scheme: dark) {
      .duplicate-tab-fullscreen {
        background-color: #1a1a1a;
      }
      
      .duplicate-tab-message h1 {
        color: #ffffff;
      }
    }

    /* Mobile responsive */
    @media (max-width: 768px) {
      .duplicate-tab-message {
        padding: 20px;
      }
      
      .duplicate-tab-message h1 {
        font-size: 24px;
      }
    }
  `]
})
export class DuplicateTabErrorComponent implements OnInit, OnDestroy {
  showDuplicateError = false;
  private subscription = new Subscription();
  private showErrorTimeout: any;

  constructor(private duplicateTabService: DuplicateTabGuardService) {}

  ngOnInit(): void {
    // Subscribe to duplicate tab detection
    this.subscription.add(
      this.duplicateTabService.isDuplicateTab().subscribe((isDuplicate: boolean) => {
        if (isDuplicate) {
          // Show error immediately for new duplicate tabs
          if (this.showErrorTimeout) {
            clearTimeout(this.showErrorTimeout);
          }
          this.showDuplicateError = true;
          this.disablePageInteractions();
        } else {
          // Add small delay when hiding error to prevent flickering on tab switch
          if (this.showErrorTimeout) {
            clearTimeout(this.showErrorTimeout);
          }
          this.showErrorTimeout = setTimeout(() => {
            this.showDuplicateError = false;
            this.enablePageInteractions();
          }, 150);
        }
      })
    );
  }

  ngOnDestroy(): void {
    // Clear timeout
    if (this.showErrorTimeout) {
      clearTimeout(this.showErrorTimeout);
    }
    this.subscription.unsubscribe();
    this.enablePageInteractions();
  }

  /**
   * Disable page interactions
   */
  private disablePageInteractions(): void {
    document.body.style.overflow = 'hidden';
  }

  /**
   * Enable page interactions
   */
  private enablePageInteractions(): void {
    document.body.style.overflow = '';
  }
}
